<template>
  <div class="articlecomment">
    <div class="pageTitle">文章评论审核</div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      >
      <div class="articlebox" v-for="(item,index) in list" :key="'list_' + item.id">
        <div class="articletitle">{{item.archive_title}}</div>
        <div class="articlecontent">{{item.content}}</div>
        <div class="articlebind">
          <van-row gutter="20">
            <van-col span="8" @click="adminDel(item.id,index)">管理员删除</van-col>
            <van-col span="8" style="text-align: center;" @click="adminAudit(1,item.id,index)">审核通过</van-col>
            <van-col span="8" style="text-align: right;" @click="adminAudit(2,item.id,index)">审核不通过</van-col>
          </van-row>
        <!-- <van-row gutter="20" style="margin-top: 12px;">
          <van-col span="8">更多功能</van-col>
        </van-row> -->
      </div>
      <div class="articlebind" style="margin-top: 20px;" v-if="item.is_delay==0">
        <van-row gutter="20">
          <van-col span="8" @click="adminAuditAfter(item.id,index)">留后审核</van-col>
        </van-row>
      </div>
    </div>
  </van-list>
</van-pull-refresh>
</div>
</template>
<script>
  import admin from '../../api/admin';
  import { mapState } from 'vuex';
  import { List,Col, Row,Dialog,Toast,PullRefresh } from 'vant';
  export default {
    data () {
      return {
        finished:false,
        loading:false,
        refreshing:false,
        params:{
          page:1,
          size:6
        },
        list:[],
        img:{
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      if(localStorage.getItem('adminToken')){
        var newTime = new Date();
        var Year = newTime.getFullYear()
        var Month = newTime.getMonth() + 1
        var Day = newTime.getDate() 
        var LoginTime=Year.toString()+Month.toString()+Day.toString()
        var localLoginTime=localStorage.getItem('LoginTime')
        if(LoginTime==localLoginTime){
          
        }else{
          this.$router.push({name:'AdminLogin'});
        }
      }else{
        this.$router.push({name:'AdminLogin'});
      }
    },
    watch: {
     '$route'() {
      if(this.$route.params.newtime){
        if(this.$route.params.newtime != this.newtime) {
          this.list=[]
          this.params.page = 1
          this.onLoad()
        }
      }
      
    }
  },
  methods: {
    adminDel(id,index){
      Dialog.alert({
        message: '确认管理员删除',
        showCancelButton:true,
        confirmButtonColor:'#005DA3',
      }).then(() => {
        admin.delArticleComment(id).then(res => {
          if(res.data.state == 1){
            Toast.success('删除成功');
            this.list.splice(index,1);
          }
        })
      })
    },
    adminAudit(type,id,index){
      if(type==1){
        var message='确认审核通过'
      }else{
        var message='确认审核不通过'
      }
      Dialog.alert({
        message: message,
        showCancelButton:true,
        confirmButtonColor:'#005DA3',
      }).then(() => {
        var params={
          id:id,
          type:type
        }
        admin.ArticleCommentAudit(params).then(res => {
          if(res.data.state == 1){
            Toast.success('审核成功');
            this.list.splice(index,1);
          }
        })
      })
    },
    adminAuditAfter(id,index){
      Dialog.alert({
        message: '确认留后审核吗？',
        showCancelButton:true,
        confirmButtonColor:'#005DA3',
      }).then(() => {
        var params={
          id:id,
        }
        admin.aArticleAuditAfter(params).then(res => {
          if(res.data.state == 1){
            Toast.success('修改成功');
            var list=this.list
            list[index].is_delay=1
            // this.list=list
            this.list.splice(index,1);
            if(list.length<6){
              this.onLoad()
            }
          }
        })

      })
    },
    onLoad() {
      admin.getArticleComment(this.params).then(res => {
        this.list.push.apply(this.list, res.data.data.data)
        this.params.page += 1
        this.loading = false
        this.refreshing=false
        if(res.data.data.data.length == 0) {
          this.finished = true
        }
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.list=[]
      this.params.page=1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.isLoading = false;
      this.onLoad();
    },
  },
  components: {
    [List.name]:List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Dialog.name]:Dialog,
    [Toast.name]:Toast,
    [PullRefresh.name]:PullRefresh
  }
}
</script>
<style lang="scss">
.articlecomment{
  .articlebox{
    margin: 15px;
    padding: 15px;
    border: 1px solid #666666;
    color: #000000;
    .articletitle{
      font-size: 14px;
      text-align: center;
      padding-bottom: 15px;
      border-bottom: 1px solid #EEEEEE;
    }
    .articlecontent{
      display: flex;
      min-height: 50px;
      font-size: 12px;
      text-align: center;
      padding: 15px 0;
      border-bottom: 1px solid #EEEEEE;
      justify-content: center;
      align-items: center;
      word-break:break-all;
    }
    .articlebind{
      color: #0C08BF;
      padding-top:15px;
      font-size: 12px;
      .van-col{
        text-decoration: underline;
      }
    }
  }
}
</style>
